export default __webpack_public_path__ + "static/media/1354.71d18bc1.png";